"use strict";

exports.__esModule = true;
exports.BarChart = BarChart;
exports.normalizeWidth = normalizeWidth;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function normalizeWidth(width) {
  if (width > 100) {
    return 100;
  }
  if (width < 0) {
    return 0;
  }
  return width;
}
function BarChart(props) {
  var hoverable = props.hoverable,
    backgroundColor = props.backgroundColor,
    value = props.value,
    maxValue = props.maxValue,
    minValue = props.minValue,
    style = props.style,
    labelValue = props.labelValue;
  var maxWidth = maxValue - minValue;
  var barWidth = normalizeWidth((value - minValue) / maxWidth * 100);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "DataTableBarChart",
    style: Object.assign({
      width: "100%",
      backgroundColor: "#e6e6e6",
      borderRadius: "2px"
    }, style),
    title: hoverable && labelValue ? labelValue : ""
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testcolor": backgroundColor,
    "data-testwidth": barWidth || "",
    style: {
      width: barWidth + "%",
      height: "100%",
      backgroundColor: backgroundColor,
      borderRadius: "2px",
      transition: "all .2s ease-out"
    }
  }));
}